<div class="panel panel-cell panel-thead">
	<div class="row no-gutters">

		<div data-testid="SUBSYS5_PATLIST_HEADER_PLANID" class="col" [class.active]="activeColumn() === fields.planId">
			<tsp-sortable-header [name]="fields.planId" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PLAN_ID }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_PATLIST_HEADER_FRAMEID" class="col" [class.active]="activeColumn() === fields.frameId">
			<tsp-sortable-header [name]="fields.frameId" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_FRAME_ID }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_PATLIST_HEADER_BONE" class="col" [class.active]="activeColumn() === fields.boneType">
			<tsp-sortable-header [name]="fields.boneType" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PLAN_BONE }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_PATLIST_HEADER_SIDE" class="col" [class.active]="activeColumn() === fields.side">
			<tsp-sortable-header [name]="fields.side" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PLAN_SIDE }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_PATLIST_HEADER_STATUS" class="col" [class.active]="activeColumn() === fields.planStatus">
			<tsp-sortable-header [name]="fields.planStatus" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PLAN_STATUS }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_PATLIST_HEADER_STATUS_DATE" class="col"
			[class.active]="activeColumn() === fields.statusDate">
			<tsp-sortable-header [name]="fields.statusDate" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PLAN_STATUS_DATE }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_PATLIST_HEADER_ACTIONS" class="col no-link stretch-col"
			[class.shrinked]="!isFiltersCollapsed()">
			{{ labels().PATIENT_TABLE_COMPONENT_ACTIONS }}
		</div>

	</div>
</div>

@for (plan of sortedList(); track $index) {
<div class="panel panel-cell panel-tr">
	<div class="row no-gutters">

		<div data-testid="SUBSYS5_PATLIST_CELL_PLANID" class="col">
			<a href="" onclick="return false;" (click)="planSettings(plan.caseId)">
				{{ plan.caseNumber }}
			</a>
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_FRAMEID" class="col">
			{{ plan.frameID }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_BONE" class="col">
			{{ plan.boneType | boneTypeLabel }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_SIDE" class="col">
			{{ plan.side | anatomicalSideLabel }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_STATUS" class="col">
			<div class="d-flex justify-content-evenly align-items-center flex-wrap">
				<div class="w-75">{{ plan.status | planStatusLabel }}</div>
				<div class="d-flex align-items-center w-25">
					@if (plan.status === status.PUBLISHED) {
					<img class="m-auto published-icon" alt="published icon" />
					} @else if (plan.status === status.REVOKED) {
					<img class="m-auto revoked-icon" alt="revoked icon" />
					}
				</div>
			</div>
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_STATUS_DATE" class="col">
			{{ plan.stateModificationDate| convertDate:false:true }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_ACTIONS" class="col no-link stretch-col"
			[class.shrinked]="!isFiltersCollapsed()">
			<div ngbDropdown container="body">
				<i data-testid="SUBSYS5_PATLIST_ACTION_PLANSETTINGS" class="material-icons action"
					[title]="labels().PATIENT_TABLE_COMPONENT_PLANSETTINGS_BTN" (click)="planSettings(plan.caseId!)"
					(keypress)="planSettings(plan.caseId!)">
					settings_applications
				</i>
				<i data-testid="SUBSYS5_PATLIST_ACTION_PATHISTORY" class="material-icons action"
					[title]="labels().PATIENT_TABLE_COMPONENT_VIEWPLAN_BTN" (click)="viewPlan(plan.caseId!, plan!.status)"
					(keypress)="viewPlan(plan.caseId!, plan!.status)">
					visibility
				</i>
			</div>
		</div>

	</div>
</div>
}